/**
 * SolidSearch – Frontend JavaScript Bundle
 *
 * Gebündelt aus: autocomplete.tpl (Dropdown), AutocompleteBoot::buildWidgetHtml
 * (Overlay), search-results.tpl (Filter/Lazy-Load/Off-Canvas), debug-search.tpl
 * (Testseite).
 *
 * Laufzeit-Config kommt aus:
 *   - #ss-overlay[data-*]           (Overlay: Shop-URL, Flags, I18N-Strings)
 *   - #result-wrapper[data-*]       (Suchergebnisse: Base-URL, Query, Filter, Sort)
 *   - body.ss-debug-page[data-*]    (Debug-Testseite: Shop-URL)
 *
 * Event-Delegation via data-ss-* Attribute (statt Inline-onchange).
 * Keine globalen Variablen außer window.ssApplyHighlights (Lazy-Load-Callback).
 */
(function () {
    'use strict';

    // =========================================================================
    // 1. Helpers
    // =========================================================================
    function escH(s) {
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function formatPrice(n) {
        return n.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + '\u00a0\u20ac';
    }

    function parseJsonAttr(el, name, fallback) {
        if (!el) { return fallback; }
        var raw = el.getAttribute(name);
        if (!raw) { return fallback; }
        try { return JSON.parse(raw); } catch (_) { return fallback; }
    }

    // =========================================================================
    // 2. Autocomplete-Overlay
    //    (vormals AutocompleteBoot::buildWidgetHtml Heredoc)
    // =========================================================================
    function initOverlay() {
        var overlay = document.getElementById('ss-overlay');
        if (!overlay) { return; }

        var overlayInput  = document.getElementById('ss-overlay-input');
        var results       = document.getElementById('ss-overlay-results');
        var closeBtn      = document.getElementById('ss-overlay-close');
        var recentSection = document.getElementById('ss-recent-section');
        var recentList    = document.getElementById('ss-recent-list');
        var recentClearBtn = document.getElementById('ss-recent-clear');
        if (!overlayInput || !results) { return; }

        var SHOP_URL      = overlay.getAttribute('data-shop-url') || '';
        var IO_URL        = SHOP_URL + '/io';
        var LANG_ID       = parseInt(overlay.getAttribute('data-lang-id') || '0', 10);
        var SHOW_IMAGES   = overlay.getAttribute('data-show-images')   === '1';
        var SHOW_PRICES   = overlay.getAttribute('data-show-prices')   === '1';
        var SHOW_PAGES    = overlay.getAttribute('data-show-pages')    === '1';
        var SHOW_EXTERNAL = overlay.getAttribute('data-show-external') === '1';
        var LANG          = parseJsonAttr(overlay, 'data-lang', {});

        var DEBOUNCE_MS = 180;
        var MIN_CHARS   = 2;
        var SS_RECENT_KEY = 'ss_recent';
        var SS_RECENT_MAX = 10;

        var shopInputs = document.querySelectorAll(
            '#search-header,input[name="qs"],input[name="suche"],input[name="search"]'
        );
        shopInputs.forEach(function (inp) {
            inp.addEventListener('focus', function () { openOverlay(inp.value); });
            inp.addEventListener('keydown', function (e) {
                if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
                    openOverlay(inp.value + e.key);
                }
            });
        });

        closeBtn.addEventListener('click', closeOverlay);
        overlay.addEventListener('click', function (e) {
            var box = document.getElementById('ss-overlay-box');
            if (e.target === overlay || (box && e.target === box.parentNode)) {
                closeOverlay();
            }
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { closeOverlay(); }
        });

        var debounceTimer = null;
        var currentQuery  = '';
        var activeIdx     = -1;

        overlayInput.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            var q = this.value.trim();
            currentQuery = q;
            if (q.length < MIN_CHARS) {
                results.innerHTML = '';
                loadRecentSearches();
                return;
            }
            if (recentSection) { recentSection.style.display = 'none'; }
            debounceTimer = setTimeout(function () { fetchSuggestions(q); }, DEBOUNCE_MS);
        });

        overlayInput.addEventListener('keydown', function (e) {
            var items = results.querySelectorAll('.ss-item');
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                activeIdx = Math.min(activeIdx + 1, items.length - 1);
                setActive(items);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                activeIdx = Math.max(activeIdx - 1, -1);
                setActive(items);
            } else if (e.key === 'Enter') {
                if (activeIdx >= 0 && items[activeIdx]) {
                    e.preventDefault();
                    items[activeIdx].click();
                } else {
                    submitSearch(overlayInput.value);
                }
            }
        });

        function openOverlay(initialValue) {
            overlayInput.value = initialValue || '';
            overlay.style.display = 'block';
            document.body.style.overflow = 'hidden';
            setTimeout(function () {
                overlayInput.focus();
                overlayInput.setSelectionRange(9999, 9999);
            }, 30);
            var q = overlayInput.value.trim();
            if (q.length >= MIN_CHARS) {
                fetchSuggestions(q);
            } else {
                results.innerHTML = '';
                loadRecentSearches();
            }
        }

        function closeOverlay() {
            overlay.style.display = 'none';
            document.body.style.overflow = '';
            results.innerHTML = '';
            if (recentSection) { recentSection.style.display = 'none'; }
            activeIdx = -1;
            shopInputs.forEach(function (inp) { inp.value = overlayInput.value; });
        }

        function submitSearch(q) {
            var term = q.trim();
            if (!term) { return; }
            persistRecentSearch(term);
            closeOverlay();
            window.location.href = SHOP_URL + '/solidsearch/results?q=' + encodeURIComponent(term);
        }

        function fetchSuggestions(query) {
            currentQuery = query;
            activeIdx = -1;
            var ioParam = JSON.stringify({ name: 'ssAutocomplete', params: [query, LANG_ID] });
            var url = IO_URL + '?io=' + encodeURIComponent(ioParam);
            fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (data) {
                    if (!data || currentQuery !== query) { return; }
                    render(data, query);
                })
                .catch(function () {});
        }

        function render(data, query) {
            var html = '';
            var any  = false;

            if (data.products && data.products.length) {
                html += '<div class="ss-sec">' + escH(LANG.products || 'Produkte') + '</div>';
                data.products.forEach(function (p) {
                    any = true;
                    var img = SHOW_IMAGES && p.image
                        ? '<img src="' + escH(p.image) + '" alt="" class="ss-item-img">'
                        : '';
                    // FEAT-005: priceBase wird vom Backend nur gesetzt, wenn ein
                    // aktiver Sonderpreis greift (priceBase > price). Wir rendern
                    // ihn als durchgestrichenen Streichpreis vor dem Effektivpreis.
                    var priceBase = SHOW_PRICES && p.priceBase != null && p.price != null && p.priceBase > p.price
                        ? '<s class="ss-item-price-base">' + formatPrice(p.priceBase) + '</s> '
                        : '';
                    var priceClass = priceBase ? 'ss-item-price ss-item-price-sale' : 'ss-item-price';
                    var price = SHOW_PRICES && p.price != null
                        ? '<span class="' + priceClass + '">' + priceBase + formatPrice(p.price) + '</span>'
                        : '';
                    html += '<a class="ss-item" href="' + escH(p.url || '#') + '">' + img
                        + '<span class="ss-item-info"><span class="ss-item-name">'
                        + escH(p.name || '') + '</span>' + price + '</span></a>';
                });
            }
            if (data.categories && data.categories.length) {
                html += '<div class="ss-sec">' + escH(LANG.categories || 'Kategorien') + '</div>';
                data.categories.forEach(function (c) {
                    any = true;
                    html += '<a class="ss-item" href="' + escH(c.url || '#')
                        + '"><span class="ss-item-text">' + escH(c.name || '')
                        + '</span><span class="ss-item-badge">'
                        + escH(LANG.badgeCategory || 'Kategorie') + '</span></a>';
                });
            }
            if (data.manufacturers && data.manufacturers.length) {
                html += '<div class="ss-sec">' + escH(LANG.manufacturers || 'Hersteller') + '</div>';
                data.manufacturers.forEach(function (m) {
                    any = true;
                    html += '<a class="ss-item" href="' + escH(m.url || '#')
                        + '"><span class="ss-item-text">' + escH(m.name || '')
                        + '</span><span class="ss-item-badge">'
                        + escH(LANG.badgeManufacturer || 'Hersteller') + '</span></a>';
                });
            }
            if (data.pages && data.pages.length) {
                var hasContent  = data.pages.some(function (p) { return !p.external; });
                var hasExternal = data.pages.some(function (p) { return p.external; });
                if (SHOW_PAGES && hasContent) {
                    html += '<div class="ss-sec">' + escH(LANG.pages || 'Seiten') + '</div>';
                    data.pages.forEach(function (p) {
                        if (p.external) { return; }
                        any = true;
                        html += '<a class="ss-item" href="' + escH(p.url || '#')
                            + '"><span class="ss-item-text">' + escH(p.name || '')
                            + '</span><span class="ss-item-badge">'
                            + escH(LANG.badgePage || 'Seite') + '</span></a>';
                    });
                }
                if (SHOW_EXTERNAL && hasExternal) {
                    html += '<div class="ss-sec">' + escH(LANG.external || 'Externe Seiten') + '</div>';
                    data.pages.forEach(function (p) {
                        if (!p.external) { return; }
                        any = true;
                        html += '<a class="ss-item" href="' + escH(p.url || '#')
                            + '"><span class="ss-item-text">' + escH(p.name || '')
                            + '</span><span class="ss-item-badge">'
                            + escH(LANG.badgeExternal || 'Extern') + '</span></a>';
                    });
                }
            }
            if (!any) {
                html = '<div class="ss-empty">'
                    + escH(LANG.noResults || 'Keine Vorschläge für')
                    + ' \u201e' + escH(query) + '\u201c</div>';
                if (data.suggestion) {
                    html += '<div class="ss-did-you-mean">'
                        + escH(LANG.didYouMean || 'Meintest du') + ': '
                        + '<a href="' + SHOP_URL + '/solidsearch/results?q='
                        + encodeURIComponent(data.suggestion) + '">'
                        + escH(data.suggestion) + '</a>?</div>';
                }
            } else {
                var countLabel = data.totalHits > 0 ? ' (' + data.totalHits + ')' : '';
                html += '<a class="ss-all-link" href="' + SHOP_URL + '/solidsearch/results?q='
                    + encodeURIComponent(query) + '">'
                    + escH(LANG.allResults || 'Alle Ergebnisse ansehen')
                    + countLabel + ' &rarr;</a>';
            }
            results.innerHTML = html;
        }

        function setActive(items) {
            items.forEach(function (el, i) {
                el.classList.toggle('active', i === activeIdx);
            });
            if (activeIdx >= 0 && items[activeIdx]) {
                var n = items[activeIdx].querySelector('.ss-item-name,.ss-item-text');
                if (n) { overlayInput.value = n.textContent.trim(); }
            }
        }

        function persistRecentSearch(term) {
            if (!term || term.length < 2) { return; }
            try {
                var arr = JSON.parse(localStorage.getItem(SS_RECENT_KEY) || '[]');
                arr = [term].concat(arr.filter(function (t) { return t !== term; })).slice(0, SS_RECENT_MAX);
                localStorage.setItem(SS_RECENT_KEY, JSON.stringify(arr));
            } catch (_) {}
        }

        function loadRecentSearches() {
            if (!recentSection || !recentList) { return; }
            try {
                var arr = JSON.parse(localStorage.getItem(SS_RECENT_KEY) || '[]');
                if (!arr.length) { recentSection.style.display = 'none'; return; }
                recentList.innerHTML = arr.map(function (t) {
                    return '<div class="ss-recent-item" tabindex="0" data-term="'
                        + escH(t) + '"><span style="color:#ccc;margin-right:4px">&#8635;</span>'
                        + escH(t) + '</div>';
                }).join('');
                recentSection.style.display = '';
            } catch (_) {}
        }

        function clearRecentSearches() {
            try { localStorage.removeItem(SS_RECENT_KEY); } catch (_) {}
            if (recentSection) { recentSection.style.display = 'none'; }
        }

        if (recentClearBtn) {
            recentClearBtn.addEventListener('click', clearRecentSearches);
        }
        if (recentList) {
            recentList.addEventListener('click', function (e) {
                var item = e.target.closest('.ss-recent-item');
                if (item && item.dataset.term) { submitSearch(item.dataset.term); }
            });
            recentList.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    var item = document.activeElement;
                    if (item && item.classList.contains('ss-recent-item') && item.dataset.term) {
                        submitSearch(item.dataset.term);
                    }
                }
            });
        }
        results.addEventListener('click', function (e) {
            if (e.target.closest('.ss-item') && currentQuery.length >= MIN_CHARS) {
                persistRecentSearch(currentQuery);
            }
        });
    }

    // =========================================================================
    // 3. Suchergebnisseite (Filter-Delegation + Off-Canvas + Lazy-Load)
    //    (vormals search-results.tpl inline)
    // =========================================================================
    function initSearchResults() {
        var wrapper = document.getElementById('result-wrapper');
        if (!wrapper) { return; }

        var BASE    = wrapper.getAttribute('data-ss-base-url') || '';
        var QUERY   = wrapper.getAttribute('data-ss-query')    || '';
        var SORT    = wrapper.getAttribute('data-ss-sort')     || '0';
        var PER_PAGE = parseInt(wrapper.getAttribute('data-ss-per-page') || '20', 10);
        var CURRENT = parseJsonAttr(wrapper, 'data-ss-filters', {});

        function buildUrl(overrides) {
            var params = new URLSearchParams();
            params.set('q', QUERY);

            var sort = (overrides && 'sort' in overrides) ? overrides.sort : SORT;
            if (sort && sort !== '0') { params.set('sort', sort); }
            if (PER_PAGE !== 20) { params.set('perPage', PER_PAGE); }

            var mf = (overrides && 'mf' in overrides) ? overrides.mf : (CURRENT.mf || []);
            if (Array.isArray(mf)) { mf.forEach(function (id) { params.append('mf[]', id); }); }

            var cf = (overrides && 'cf' in overrides) ? overrides.cf : (CURRENT.cf || []);
            if (Array.isArray(cf)) { cf.forEach(function (v) { params.append('cf[]', v); }); }

            var pmin = (overrides && 'pmin' in overrides) ? overrides.pmin : CURRENT.pmin;
            if (pmin) { params.set('pmin', pmin); }

            var pmax = (overrides && 'pmax' in overrides) ? overrides.pmax : CURRENT.pmax;
            if (pmax) { params.set('pmax', pmax); }

            var avail = (overrides && 'avail' in overrides) ? overrides.avail : CURRENT.avail;
            if (avail) { params.set('avail', avail); }

            return BASE + '?' + params.toString();
        }

        function applyFilter(name, value, isMulti) {
            var overrides = {};
            if (name === 'mf[]' || name === 'cf[]') {
                var key = name.slice(0, -2);
                if (isMulti) {
                    overrides[key] = value ? [value] : [];
                } else {
                    var arr = (CURRENT[key] || []).slice();
                    var idx = arr.indexOf(value);
                    if (value && idx === -1) { arr.push(value); }
                    else if (idx !== -1) { arr.splice(idx, 1); }
                    overrides[key] = arr;
                }
            } else {
                overrides[name] = value;
            }
            window.location.href = buildUrl(overrides);
        }

        function applyMerkmalFilter(kMerkmal, kWert) {
            var current = (CURRENT.cf || []).slice().filter(function (v) {
                return String(v).split('_')[0] != kMerkmal;
            });
            if (kWert) { current.push(kMerkmal + '_' + kWert); }
            window.location.href = buildUrl({ cf: current });
        }

        // Event-Delegation: data-ss-filter="name" [data-ss-filter-multi] [data-ss-filter-bool]
        //                   data-ss-merkmal="kMerkmal"
        //                   data-ss-submit-form
        wrapper.addEventListener('change', function (e) {
            var t = e.target;
            if (!t) { return; }

            if (t.hasAttribute('data-ss-submit-form')) {
                var form = t.form || t.closest('form');
                if (form) { form.submit(); }
                return;
            }

            var filterName = t.getAttribute('data-ss-filter');
            if (filterName) {
                var isMulti = t.hasAttribute('data-ss-filter-multi');
                var isBool  = t.hasAttribute('data-ss-filter-bool');
                var boolOn  = t.getAttribute('data-ss-filter-bool-on') || '';
                var value;
                if (isBool) {
                    value = t.checked ? boolOn : '';
                } else {
                    value = t.value;
                }
                applyFilter(filterName, value, isMulti);
                return;
            }

            var kMerkmal = t.getAttribute('data-ss-merkmal');
            if (kMerkmal !== null) {
                applyMerkmalFilter(parseInt(kMerkmal, 10), t.value);
            }
        });

        // Sticky-Toolbar Scroll-Shadow: IntersectionObserver auf einen Sentinel
        // unmittelbar VOR der Toolbar — wenn der Sentinel aus dem Viewport
        // scrollt, "klebt" die Toolbar und bekommt .is-stuck (verstärkter Schatten).
        var toolbar = wrapper.querySelector('.ss-toolbar');
        if (toolbar && 'IntersectionObserver' in window) {
            var sentinel = document.createElement('div');
            sentinel.setAttribute('aria-hidden', 'true');
            sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
            toolbar.parentNode.insertBefore(sentinel, toolbar);
            var stickyObs = new IntersectionObserver(function (entries) {
                toolbar.classList.toggle('is-stuck', !entries[0].isIntersecting);
            }, { threshold: [0], rootMargin: '0px 0px 0px 0px' });
            stickyObs.observe(sentinel);
        }

        // Off-Canvas (Bootstrap 4 hat kein offcanvas-Modul)
        var ocPanel    = document.getElementById('ssFilterOffcanvas');
        var ocBackdrop = document.getElementById('ssOffcanvasBackdrop');
        var ocToggle   = document.getElementById('ssFilterToggle');
        var ocClose    = ocPanel ? ocPanel.querySelector('.ss-offcanvas-close') : null;

        function openOffcanvas() {
            if (!ocPanel) { return; }
            ocPanel.classList.add('show');
            if (ocBackdrop) { ocBackdrop.classList.add('show'); }
            document.body.classList.add('ss-offcanvas-open');
            ocPanel.setAttribute('aria-hidden', 'false');
        }
        function closeOffcanvas() {
            if (!ocPanel) { return; }
            ocPanel.classList.remove('show');
            if (ocBackdrop) { ocBackdrop.classList.remove('show'); }
            document.body.classList.remove('ss-offcanvas-open');
            ocPanel.setAttribute('aria-hidden', 'true');
        }
        if (ocToggle) { ocToggle.addEventListener('click', openOffcanvas); }
        if (ocClose) { ocClose.addEventListener('click', closeOffcanvas); }
        if (ocBackdrop) { ocBackdrop.addEventListener('click', closeOffcanvas); }
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && ocPanel && ocPanel.classList.contains('show')) {
                closeOffcanvas();
            }
        });

        // Lazy-Load via IntersectionObserver
        var sentinel = document.getElementById('ssLazyLoadSentinel');
        if (sentinel && 'IntersectionObserver' in window) {
            var loading = false;
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting || loading) { return; }
                    var nextPage   = parseInt(sentinel.getAttribute('data-next-page'), 10);
                    var totalPages = parseInt(sentinel.getAttribute('data-total-pages'), 10);
                    if (nextPage > totalPages) {
                        observer.disconnect();
                        sentinel.style.display = 'none';
                        return;
                    }
                    loading = true;
                    var url = buildUrl({}) + '&p=' + nextPage + '&partial=1';
                    fetch(url, { headers: { 'X-Solidsearch-Partial': '1' } })
                        .then(function (r) { return r.ok ? r.text() : null; })
                        .then(function (html) {
                            if (!html) { loading = false; return; }
                            var grid = document.getElementById('ssProductGrid');
                            var temp = document.createElement('div');
                            temp.innerHTML = html;
                            while (temp.firstChild) { grid.appendChild(temp.firstChild); }
                            sentinel.setAttribute('data-next-page', nextPage + 1);
                            if (window.ssApplyHighlights) { window.ssApplyHighlights(grid); }
                            if (nextPage + 1 > totalPages) {
                                observer.disconnect();
                                sentinel.style.display = 'none';
                            }
                            loading = false;
                        })
                        .catch(function () { loading = false; });
                });
            }, { rootMargin: '400px 0px' });
            observer.observe(sentinel);
        }

        // Highlighting: NOVA productbox-title em-Tags aus ES-Result applizieren
        var highlightsNode = document.getElementById('ssHighlightsData');
        if (highlightsNode) {
            var highlights = parseJsonAttr(highlightsNode, 'data-highlights', {});
            var applyHighlights = function (scope) {
                for (var k in highlights) {
                    if (!highlights.hasOwnProperty(k) || !highlights[k] || !highlights[k].name) { continue; }
                    var safe = String(highlights[k].name[0] || '').replace(/<(?!\/?(em)(?=>|\s))\/?[^>]+>/gi, '');
                    var el = (scope || document).querySelector('#ss_result-wrapper_buy_form_' + k + ' .productbox-title a');
                    if (el) { el.innerHTML = safe; }
                }
            };
            window.ssApplyHighlights = applyHighlights;
            applyHighlights(document);
        }
    }

    // =========================================================================
    // 4. Debug-Testseite (Standalone /solidsearch/debug-search)
    //    (vormals debug-search.tpl inline)
    // =========================================================================
    function initDebugPage() {
        var body = document.body;
        if (!body.classList.contains('ss-debug-page')) { return; }

        var SHOP_URL = body.getAttribute('data-shop-url') || '';
        var IO_URL   = SHOP_URL + '/io';
        var DEBOUNCE_MS = 200;
        var MIN_CHARS   = 2;

        var input     = document.getElementById('ss-debug-input');
        var results   = document.getElementById('ss-debug-results');
        var submitBtn = document.getElementById('ss-debug-submit');
        if (!input || !results) { return; }

        var debounceTimer = null;
        var currentQuery  = '';

        input.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            var q = this.value.trim();
            currentQuery = q;
            if (q.length < MIN_CHARS) { results.innerHTML = ''; return; }
            debounceTimer = setTimeout(function () { fetchSuggestions(q); }, DEBOUNCE_MS);
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                doFullSearch(input.value.trim());
            }
        });

        if (submitBtn) {
            submitBtn.addEventListener('click', function () {
                doFullSearch(input.value.trim());
            });
        }

        function doFullSearch(q) {
            if (!q || q.length < MIN_CHARS) { return; }
            window.location.href = SHOP_URL + '/search/?qs=' + encodeURIComponent(q);
        }

        function fetchSuggestions(query) {
            currentQuery = query;
            var ioParam = JSON.stringify({ name: 'ssAutocomplete', params: [query, 0] });
            var url = IO_URL + '?io=' + encodeURIComponent(ioParam);
            fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (data) {
                    if (!data || currentQuery !== query) { return; }
                    render(data, query);
                })
                .catch(function () {});
        }

        function render(data, query) {
            var html = '';
            var any  = false;
            if (data.products && data.products.length) {
                html += '<div class="ss-debug-sec">Produkte</div>';
                data.products.forEach(function (p) {
                    any = true;
                    var img = p.image ? '<img src="' + escH(p.image) + '" alt="" class="ss-debug-item-img">' : '';
                    // FEAT-005 Streichpreis (Debug-Pfad zeigt ihn ebenfalls,
                    // damit Operatoren sehen, dass ein Sonderpreis im Index liegt).
                    var priceBase = p.priceBase != null && p.price != null && p.priceBase > p.price
                        ? '<s class="ss-debug-item-price-base">' + formatPrice(p.priceBase) + '</s> '
                        : '';
                    var price = p.price != null
                        ? '<span class="ss-debug-item-price">' + priceBase + formatPrice(p.price) + '</span>'
                        : '';
                    html += '<a class="ss-debug-item" href="' + escH(p.url || '#') + '">' + img
                        + '<span class="ss-debug-item-info"><span class="ss-debug-item-name">'
                        + escH(p.name || '') + '</span>' + price + '</span></a>';
                });
            }
            if (data.categories && data.categories.length) {
                html += '<div class="ss-debug-sec">Kategorien</div>';
                data.categories.forEach(function (c) {
                    any = true;
                    html += '<a class="ss-debug-item" href="' + escH(c.url || '#')
                        + '"><span class="ss-debug-item-name">' + escH(c.name || '')
                        + '</span><span class="ss-debug-item-badge">Kategorie</span></a>';
                });
            }
            if (data.manufacturers && data.manufacturers.length) {
                html += '<div class="ss-debug-sec">Hersteller</div>';
                data.manufacturers.forEach(function (m) {
                    any = true;
                    html += '<a class="ss-debug-item" href="' + escH(m.url || '#')
                        + '"><span class="ss-debug-item-name">' + escH(m.name || '')
                        + '</span><span class="ss-debug-item-badge">Hersteller</span></a>';
                });
            }
            if (data.pages && data.pages.length) {
                html += '<div class="ss-debug-sec">Seiten</div>';
                data.pages.forEach(function (p) {
                    any = true;
                    html += '<a class="ss-debug-item" href="' + escH(p.url || '#')
                        + '"><span class="ss-debug-item-name">' + escH(p.name || '')
                        + '</span><span class="ss-debug-item-badge">'
                        + (p.external ? 'Extern' : 'Seite') + '</span></a>';
                });
            }
            if (!any) {
                html = '<div class="ss-debug-empty">Keine Ergebnisse f\u00fcr \u201e' + escH(query) + '\u201c</div>';
                if (data.suggestion) {
                    html += '<div class="ss-debug-did-you-mean">Meintest du: '
                        + '<a href="' + SHOP_URL + '/search/?qs=' + encodeURIComponent(data.suggestion) + '">'
                        + escH(data.suggestion) + '</a>?</div>';
                }
            } else {
                var countLabel = data.totalHits > 0 ? ' (' + data.totalHits + ')' : '';
                html += '<a class="ss-debug-all-link" href="' + SHOP_URL + '/search/?qs='
                    + encodeURIComponent(query) + '">Alle Ergebnisse ansehen' + countLabel + ' &rarr;</a>';
            }
            results.innerHTML = html;
        }
    }

    // =========================================================================
    // 5. Boot
    // =========================================================================
    function ready(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    ready(function () {
        initOverlay();
        initSearchResults();
        initDebugPage();
    });
})();
